import {Injectable} from '@angular/core';
import {BehaviorSubject, firstValueFrom, ReplaySubject, Subject} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SubService {
  openAuth: ReplaySubject<any> = new ReplaySubject(undefined);
  joinTrade: ReplaySubject<any> = new ReplaySubject(undefined);
  loadAppInit: ReplaySubject<any> = new ReplaySubject(undefined);
  appInitData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  reloadBasket: ReplaySubject<any> = new ReplaySubject<any>(0);
  emptyBasket: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  countCart: ReplaySubject<any> = new ReplaySubject<any>(0);
  cart: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  currentScreenWidth: BehaviorSubject<any> = new BehaviorSubject(null);
  isMobile: BehaviorSubject<any> = new BehaviorSubject(null);
  msrpOnly: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.getInitialMsrpOnly());

  private getInitialMsrpOnly(): boolean {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('hide_trade_price') === 'true';
    }
    return false;
  }

  setMsrpOnly(value: boolean): void {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('hide_trade_price', value ? 'true' : 'false');
    }
    this.msrpOnly.next(value);
  }

  refactorURL(string) {
    return string?.trim()
      .replace(',', '') // Remove comma
      .replace(/\./g, '') // Remove dots
      .replace(/'/g, '')  // Remove single quotes
      .replace(/\(/g, '') // Remove opening parentheses
      .replace(/\)/g, '') // Remove closing parentheses
      .replace(/&/g, '-') // Replace ampersands with dashes
      .replace(/\|/g, '-') // Replace pipes with dashes
      .replace(/ - /g, '-') // Replace ' - ' with a single dash
      .replace(/\//g, '-') // Replace slashes with dashes
      .replace(/ \/ /g, '-') // Replace ' / ' with a single dash
      .replace(/ /g, '-') // Replace spaces with dashes
      .replace(/---+/g, '-') // Replace multiple dashes with a single dash
      .replace(/--+/g, '-') // Replace multiple dashes with a single dash
      .replace(/^-+|-+$/g, '') // Remove leading and trailing dashes
      .toLowerCase(); // Convert to lowercase
  }

}
